import { render, staticRenderFns } from "./ChartConfig.vue?vue&type=template&id=5cc4e751"
import script from "./ChartConfig.vue?vue&type=script&lang=js"
export * from "./ChartConfig.vue?vue&type=script&lang=js"
import style0 from "./ChartConfig.vue?vue&type=style&index=0&id=5cc4e751&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports